<template>
  <div>
    <div class="info-div">
      <div class="body">
        <!--检索框-->
        <div class="search">
          <div>
            <span>{{ $t("sampleApply.order.partNo") }}：</span>
            <el-input
              v-model="searchPartNo"
              :placeholder="$t('sampleApply.order.partNoPlaceholder')"
            />
          </div>
          <div>
            <span>{{ $t("sampleApply.order.orderNo") }}：</span>
            <el-input
              v-model="searchOrderNo"
              :placeholder="$t('sampleApply.order.orderNoPlaceholder')"
            />
          </div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="conditionalListPage"
          >
            {{ $t("sampleApply.order.search") }}
          </el-button>
        </div>
        <!--样品申请列表-->
        <div class="sample-list">
          <el-table
            :data="sampleList"
            style="width: 100%; white-space: nowrap"
            @filter-change="orderStatusChange"
          >
            <el-table-column
              :label="$t('sampleApply.order.item')"
              width="60"
              type="index"
            />
            <el-table-column
              prop="orderNo"
              :label="$t('sampleApply.order.orderNo')"
            >
              <template slot-scope="scope">
                <a
                  class="order-no"
                  @click="toSampleOrderDetail(scope.row.orderNo)"
                >{{ scope.row.orderNo }}</a>
              </template>
            </el-table-column>
            <el-table-column
              prop="createTime"
              :label="$t('sampleApply.order.orderTime')"
            />
            <el-table-column
              prop="messageContent"
              :label="$t('sampleApply.order.orderStatus')"
              width="100"
              column-key="orderStatus"
              :filters="stateFilters"
              :filter-multiple="false"
              filter-placement="bottom-end"
            >
              <template slot-scope="scope">
                {{ getOrderStatus(scope.row.orderStatus) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="expressNo"
              :label="$t('sampleApply.order.expressNo')"
            >
              <template slot-scope="scope">
                {{ nullFormatter(scope.row.expressNo) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="receivePersonName, phone, province, city, country, detailAddress"
              :label="$t('sampleApply.order.receiveInfo')"
            >
              <template slot-scope="scope">
                {{ scope.row.receivePersonName }} {{ scope.row.phone }}<br>
                {{ scope.row.province }}{{ scope.row.city }}{{ scope.row.country }}{{ scope.row.detailAddress }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('sampleApply.order.operation')"
            >
              <template slot-scope="scope">
                <el-button size="mini" @click="cancelApply(scope.row.orderId)" v-if="scope.row.orderStatus != 2 && scope.row.orderStatus != 3">{{ $t("sampleApply.order.cancelOrder") }}</el-button>
                <span v-else>-</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div />
        <div class="footer">
          <el-pagination
            background
            layout="prev, pager, next, total"
            :page-size="page.size"
            :total="page.total"
            :current-page="page.current"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "SampleOrderList",
    data() {
      return {
        // 检索框商品型号
        searchPartNo: "",
        // 检索框订单编号
        searchOrderNo: "",
        searchHeader: "订单状态",
        // 订单状态筛选
        searchOrderStatus: -1,
        // 样品申请列表
        sampleList: [],
        // 订单状态的过滤条件
        stateFilters: [
          { text: this.$t("sampleApply.order.orderStatusList.waitDeal"), value: "0" },
          { text: this.$t("sampleApply.order.orderStatusList.dealing"), value: "1" },
          { text: this.$t("sampleApply.order.orderStatusList.hasSend"), value: "2" },
          { text: this.$t("sampleApply.order.orderStatusList.canceled"), value: "3" },
        ],
        page: {
          size: 10,
          total: 0,
          current: 1,
        },
      }
    },
    created() {
      this.listByPage();
    },
    methods: {
      // 弹出取消原因填写框
      cancelApply(orderId) {
        this.$prompt('', this.$t("sampleApply.order.cancelReason"), {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          closeOnClickModal: false,
          inputType: 'textarea',
          inputPlaceholder: this.$t("sampleApply.order.textLengthLimit30"),
          inputValidator: value => {
            // 数据校验
            if (value == null || value.trim() == "") {
              return this.$t("sampleApply.order.enterCancelReasonTips");
            }
            if (value.trim().length > 30) {
              return this.$t("sampleApply.order.reEnterCancelReasonTips");
            }
          }
        }).then(({ value }) => {
          let url = "/order/sample-order/cancelApply";
          let params = {
            orderId: orderId,
            userId: localStorage.getItem("userId"),
            // 订单取消原因
            cancelReason: value,
          }
          this.$doPost(url, params).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: this.$t("sampleApply.order.orderCancelSuccess"),
              });
              this.listByPage();
              this.$forceUpdate();
            }
          }).catch((err) => {
            console.log(err);
          })
        }).catch(() => {
        });
      },
      orderStatusChange(orderStatusList) {
        if (orderStatusList.orderStatus == null || orderStatusList.orderStatus.length == 0) {
          this.searchOrderStatus = "";
          this.searchHeader = "订单状态";
          this.listByPage(1);
        } else {
          this.searchOrderStatus = orderStatusList.orderStatus[0];
          this.searchHeader = this.getOrderStatus(this.searchOrderStatus);
          this.listByPage(1);
        }
      },
      // 表格格式化null值和空字符串
      nullFormatter(field) {
        if (field == null || field.trim() == "") {
          return "-";
        }
        return field;
      },
      // 将订单状态标识转换为对应的字符串
      getOrderStatus(orderStatus) {
        if (orderStatus == 0) {
          return this.$t("sampleApply.order.orderStatusList.waitDeal");
        } else if (orderStatus == 1) {
          return this.$t("sampleApply.order.orderStatusList.dealing");
        } else if (orderStatus == 2) {
          return this.$t("sampleApply.order.orderStatusList.hasSend");
        } else if (orderStatus == 3) {
          return this.$t("sampleApply.order.orderStatusList.canceled");
        } else {
          return "-";
        }
      },
      // 带检索条件的列表查询
      conditionalListPage() {
        // 当有检索条件时，默认从第一页开始
        this.listByPage(1);
      },
      // 分页获取样品申请信息列表
      listByPage(current = this.page.current) {
        let url = "/order/sample-order/listSampleOrderByPage";
        let obj = {
          partNo: this.searchPartNo != null ? this.searchPartNo.trim() : this.searchPartNo,
          orderNo: this.searchOrderNo != null ? this.searchOrderNo.trim() : this.searchOrderNo,
          orderStatus: this.searchOrderStatus,
          size: this.page.size,
          total: this.page.total,
          current: current,
          userId: localStorage.getItem("userId"),
        }
        this.$doPost(url, obj).then((res) => {
          if (res.code == 200) {
            this.sampleList = res.data.sampleOrderDTOList;
            this.page.current = res.data.current;
            this.page.size = res.data.size;
            this.page.total = res.data.total;
          }
        }).catch((err) => {
          console.log(err);
        });
      },
      // 页码发生改变
      handleCurrentChange(val) {
        this.page.current = val;
        this.listByPage();
      },
      // 订单状态过滤
      filterTag(value, row) {
        return row.orderStatus === value;
      },
      // 跳转到样品申请详情页
      toSampleOrderDetail(sampleOrderNo) {
        let routeUrl = this.$router.resolve({
          path: "/SampleOrderDetail",
          query: {
            sampleOrderNo,
          }
        });
        window.open(routeUrl.href, "_blank");
      }
    },
  }
</script>

<style scoped lang="less">
  .info-div {
    width: 1200px;
    margin: 10px auto 0;
  }
  
  .body {
    margin-top: 6px;
    
    /deep/ .el-table__cell {
      text-align: center;
    }
    
    .search {
      display: flex;
      
      > div {
        display: flex;
        align-items: center;
        margin-right: 30px;
        
        > span {
          font-weight: bold;
          width: 50%;
          white-space: nowrap;
        }
      }
    }
    
    .sample-list {
      margin-top: 15px;
      /deep/ .el-table {
        border: 1px solid #9BA0A6;
        border-radius: 5px;
      }
      .order-no, .order-no:visited {
        cursor: pointer;
        text-decoration: underline;
        color: #606266;
      }
      
      .order-no:hover {
        cursor: pointer;
        color: #5daf34;
        text-decoration: underline;
      }
    }
  }
  
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
</style>